// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import OpenPipsAside from './open-pips-aside';
import OpenPipsMain from './open-pips-main';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

const OpenPips = props =>
    <section className='open-pips'>
        <WarrantyLoadingIndicator isLoading={props.busyCounter > 0}/>
        <OpenPipsAside/>
        <OpenPipsMain/>
    </section>;

OpenPips.displayName = 'OpenPips';
OpenPips.propTypes = {
    busyCounter: PropTypes.number.isRequired
};

export default OpenPips;



// WEBPACK FOOTER //
// ./src/pip/open-pips/components/open-pips.js